export default "__VITE_ASSET__BeIcA4dQ__"